import styled from "styled-components";
import { Button, TextField, Typography } from "@mui/material";
import { theme } from "../../utils/globalStyles/colors";

export const Container = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
`;

export const Label = styled(Typography)`
  font-weight: 600 !important;
  color: #ffffff;
  font-size: 14px !important;
  margin-bottom: 8px !important;
`;

export const InputBox = styled.div`
  margin-bottom: 20px;
  width: 100%;

  & .MuiFormControl-root {
    width: 100%;
  }
`;

export const Input = styled(TextField)`
  /* Garante que o fundo branco envolva todo o input e o ícone */
  & .MuiInputBase-root {
    background: ${theme.colors.white || "#ffffff"};
    border-radius: 8px;
  }

  & input {
    font-size: 16px;
    padding: 14px 14px 14px 0; /* Tiramos o padding da esquerda para não afastar o ícone */
    color: #333;
  }

  & input::placeholder {
    color: #999999;
    opacity: 1;
  }

  & .MuiOutlinedInput-root {
    border-radius: 8px;
  }

  & .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline {
    border-color: #ffffff;
    border-width: 2px;
  }
`;

export const Buttons = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
`;

export const ForgetPassword = styled(Typography)`
  font-weight: 500 !important;
  color: #ffffff !important;
  font-size: 14px !important;
  margin-bottom: 24px !important;
  text-decoration: none !important;
  align-self: flex-end;
  cursor: pointer;
  transition: opacity 0.2s ease;

  &:hover {
    opacity: 0.8;
    text-decoration: underline !important;
  }
`;

export const Login = styled(Button)`
  background-color: ${theme.colors.white || "#ffffff"} !important;
  color: #d37228 !important; /* Cor da Mutattio Coins */
  border-radius: 10px !important;
  font-size: 18px !important;
  font-weight: bold !important;
  width: 100% !important;
  height: 56px !important;
  text-transform: none !important;
  box-shadow: 0 4px 14px rgba(0, 0, 0, 0.1) !important;

  &:hover {
    background-color: #f5f5f5 !important;
    transform: translateY(-2px);
    transition: all 0.2s ease-in-out;
  }
`;
